import { configureFetcher as configureOrdrServiceFetcher } from '@ordr-as/ordr-service-types/fetcher';
import { configureFetcher as configurePaymentServiceFetcher } from '@ordr-as/payment-service-types/fetcher';
import { useRef } from 'react';
import config from '../config';
import { useAuth } from './AuthContext';

interface ApiFetcherProviderProps {
  children: React.ReactNode;
}

export const ApiFetcherProvider = ({ children }: ApiFetcherProviderProps) => {
  const { getAccessToken } = useAuth();
  const configuredRef = useRef(false);

  // Configure synchronously during render (before children render) to avoid race conditions
  if (!configuredRef.current) {
    const getHeaders = async () => {
      const accessToken = await getAccessToken();
      return {
        Authorization: `Bearer ${accessToken}`,
      };
    };

    configureOrdrServiceFetcher({
      baseUrl: config.ordrServiceUrl,
      getHeaders,
    });

    configurePaymentServiceFetcher({
      baseUrl: config.paymentServiceUrl,
      getHeaders,
    });

    configuredRef.current = true;
  }

  return children;
};
